<template>
  <div class="bottom-info disFlex vertical">
    <div class="info-up">
      <div class="up-line disFlex Flex-center Flex-between">
        <div class="item disFlex vertical fvc">
          <img src="https://j.weizan.cn/youxiang/pre-1.png" class="item-png" />
          直播抢补贴
        </div>
        <div class="item disFlex vertical fvc">
          <img src="https://j.weizan.cn/youxiang/pre-2.png" class="item-png" />
          万元代金券
        </div>
        <div class="item disFlex vertical fvc">
          <img src="https://j.weizan.cn/youxiang/pre-3.png" class="item-png" />
          千款爆破预售
        </div>
      </div>
      <div class="up-line disFlex Flex-center Flex-around">
        <div class="item disFlex vertical fvc">
          <img src="https://j.weizan.cn/youxiang/pre-4.png" class="item-png" />
          限时特价秒杀
        </div>
        <div class="item disFlex vertical fvc">
          <img src="https://j.weizan.cn/youxiang/pre-5.png" class="item-png" />
          0消费送豪礼
        </div>
      </div>
    </div>
    <div class="info-down disFlex Flex-center Flex-between">
      <div class="info-left">
        <div class="info-title">长按识别二维码</div>
        <div class="disFlex Flex-center">
          <div class="tag" :class="skinbg">获取</div>
          <div class="tip" :class="fontcolor">最新信息</div>
        </div>
      </div>
      <div class="info-right">
        <img :src="wxMqQrcode" class="qr-code" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    wxMqQrcode: {
      type: String,
      default: "",
    },
    stylecolor: {
      type: String,
      default: "blue", 
    },
  },
  data() {
    return {
      skinbg:{},
      fontcolor: {},
    };
  },
  created() {
    if (this.stylecolor == "red") {
      this.skinbg.red_bg = true;
      this.fontcolor.red_c = true;
    } else if (this.stylecolor == "purple") {
      this.skinbg.purple_bg = true;
      this.fontcolor.purple_c = true;
    } else if (this.stylecolor == "green") {
      this.skinbg.green_bg = true;
      this.fontcolor.green_c = true;
    } else if (this.stylecolor == "yellow") {
      this.skinbg.yellow_bg = true;
      this.fontcolor.yellow_c = true;
    }
  },
};
</script>

<style lang="less" scoped>
.red_c {
  color: #b80000 !important;
}
.red_bg {
  background: #b70000 !important;
  color: #ffffff !important;
}
.purple_c {
  color: #3b13a7 !important;
}
.purple_bg {
  background: #3b13a7 !important;
  color: #ffffff !important;
}
.green_c {
  color: #14413A !important;
}
.green_bg {
  background: #14413A !important;
  color: #ffffff !important;
}
.yellow_c {
  color: #f5bb4f !important;
}
.yellow_bg {
  background: #f5bb4f !important;
  color: #ffffff !important;
}


.bottom-info {
  width: 345px;
  height: 345px;
  background: rgba(255, 254, 255, 1);
  border-radius: 15px;
  margin: 20px auto;
  .info-up {
    margin: 0 25px;
    border-bottom: 1px solid #f1e1b9;
    padding: 25px 0;
    .up-line {
      margin-bottom: 25px;
      .item {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(53, 53, 53, 1);
        .item-png {
          width: 54px;
          height: 54px;
          margin-bottom: 10px;
        }
      }
    }
    .up-line:last-child {
      margin-bottom: 0;
    }
  }
  .info-down {
    padding: 0 25px;
    padding-top: 10px;
    .info-left {
    }
    .info-title {
      font-size: 15px;
      color: #353535;
      margin-bottom: 10px;
    }
    .tag {
      width: 47px;
      height: 25px;
      line-height: 25px;
      background: rgba(0, 48, 120, 1);
      color: #fffeff;
      font-size: 19px;
      text-align: center;
    }
    .tip {
      font-size: 19px;
      color: #003078;
      font-weight: normal;
      margin-left: 5px;
    }
    .qr-code {
      width: 89px;
      height: 89px;
    }
  }
}
</style>